import { render, staticRenderFns } from "./RuleManagerPiMatchAndAssignRules.vue?vue&type=template&id=3d260cc6&scoped=true&"
import script from "./RuleManagerPiMatchAndAssignRules.vue?vue&type=script&lang=js&"
export * from "./RuleManagerPiMatchAndAssignRules.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerPiMatchAndAssignRules.vue?vue&type=style&index=0&id=3d260cc6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d260cc6",
  null
  
)

export default component.exports